import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { leaderboardApi } from '../../services/api';

// Server-side pagination: backend page/size + pagination.{total,page,size}
// döner. Slice iki tab için ayrı pagination tutar (SKS ve Yönetici bağımsız
// sayfalarda olabilir). Tab değişince son state korunur — tekrar fetch
// tetikleyen tarafı sayfa bileşeni yapar.

export const fetchLeaderboardSks = createAsyncThunk(
  'leaderboard/sks',
  async (params, { rejectWithValue }) => {
    try {
      const res = await leaderboardApi.sks(params);
      return { items: res.data, pagination: res.pagination };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const fetchLeaderboardManager = createAsyncThunk(
  'leaderboard/manager',
  async (params, { rejectWithValue }) => {
    try {
      const res = await leaderboardApi.manager(params);
      return { items: res.data, pagination: res.pagination };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const fetchUserDetail = createAsyncThunk(
  'leaderboard/userDetail',
  async (params, { rejectWithValue }) => {
    try {
      const res = await leaderboardApi.userDetail(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const exportLeaderboard = createAsyncThunk(
  'leaderboard/export',
  async (params, { rejectWithValue }) => {
    try {
      const res = await leaderboardApi.exportExcel(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

const emptyPagination = { total: 0, page: 1, size: 50 };

const initialState = {
  sks: [],
  manager: [],
  sksPagination: { ...emptyPagination },
  managerPagination: { ...emptyPagination },
  activeTab: 'sks', // 'sks' | 'manager'
  status: 'idle',
  exportStatus: 'idle',
  error: null,
  periodId: null,
  filters: { mudurluk: null, search: '' },
};

const leaderboardSlice = createSlice({
  name: 'leaderboard',
  initialState,
  reducers: {
    setTab(state, action) {
      state.activeTab = action.payload;
    },
    setPeriod(state, action) {
      state.periodId = action.payload;
      // Dönem değişince iki tab için de sayfayı başa al — eski sayfanın
      // range'i yeni toplamın dışına düşebilir.
      state.sksPagination.page = 1;
      state.managerPagination.page = 1;
    },
    setFilter(state, action) {
      state.filters = { ...state.filters, ...action.payload };
      state.sksPagination.page = 1;
      state.managerPagination.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeaderboardSks.pending, (s) => { s.status = 'loading'; s.error = null; })
      .addCase(fetchLeaderboardSks.fulfilled, (s, a) => {
        s.status = 'succeeded';
        s.sks = a.payload.items;
        if (a.payload.pagination) s.sksPagination = a.payload.pagination;
      })
      .addCase(fetchLeaderboardSks.rejected, (s, a) => { s.status = 'failed'; s.error = a.payload; })

      .addCase(fetchLeaderboardManager.pending, (s) => { s.status = 'loading'; })
      .addCase(fetchLeaderboardManager.fulfilled, (s, a) => {
        s.status = 'succeeded';
        s.manager = a.payload.items;
        if (a.payload.pagination) s.managerPagination = a.payload.pagination;
      })
      .addCase(fetchLeaderboardManager.rejected, (s, a) => { s.status = 'failed'; s.error = a.payload; })

      .addCase(exportLeaderboard.pending, (s) => { s.exportStatus = 'loading'; })
      .addCase(exportLeaderboard.fulfilled, (s) => { s.exportStatus = 'succeeded'; })
      .addCase(exportLeaderboard.rejected, (s) => { s.exportStatus = 'failed'; });
  },
});

export const { setTab, setPeriod, setFilter } = leaderboardSlice.actions;
export default leaderboardSlice.reducer;
